import * as React from 'react';
import * as classnames from 'classnames/bind';

import styles from './Cta.scss';

const cx = classnames.bind(styles);

interface CtaProps {
  title: string;
  subtitle?: string;
  backgroundType: 'circles' | 'logo';
}

const Cta: React.SFC<CtaProps> = ({ children, title, subtitle, backgroundType }) => (
  <section
    className={cx('cta', {
      circlesBg: backgroundType === 'circles',
      logoBg: backgroundType === 'logo',
    })}
    style={{ backgroundImage: `url(${require(`./${backgroundType}.svg`)})` }}
  >
    <div className="container d-flex flex-column">
      <h2 className={styles.title}>{title}</h2>
      {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
      {children && <div className={styles.content}>{children}</div>}
    </div>
  </section>
);

export default Cta;



// WEBPACK FOOTER //
// /www/client/src/components/Cta/Cta.tsx